import gql from "graphql-tag";
import getQuery from "./get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function getCloseOutCids() {
  const address = ParcisionCookies.get("address");
  const variables = {
    address,
  };

  const query = gql`
    query MyQuery($address: String!) {
      getCloseOutCids(address: $address) {
        contracts {
          cid
        }
      }
    }
  `;

  const data = await getQuery(query, variables);
  // @ts-expect-error
  return data.getCloseOutCids;
}
